module.exports = __webpack_public_path__ + "img/leader_pl_m.5da80a69.svg";